import ResetPassword from './ResetPassword';

export default {
  name: 'ResetPassword',
  location: '/reset-password',
  component: ResetPassword,
};
